import axios from 'axios';
import { applyAxiosAuth } from './axiosAuthSetup';

function getRuntimeEnvValue(key) {
  const k = typeof key === 'string' ? key.trim() : '';
  if (k.length === 0) {
    return null;
  }

  const isRealValue = (val) => {
    if (typeof val !== 'string' || val.trim().length === 0) {
      return false;
    }
    const s = val.trim();
    if (s.indexOf('${') >= 0) {
      return false;
    }
    if (s.startsWith('__') && s.endsWith('__')) {
      return false;
    }
    return true;
  };

  if (typeof window !== 'undefined' && window.env !== undefined && window.env !== null) {
    const v = window.env[k];
    if (isRealValue(v) === true) {
      return v.trim();
    }
  }

  let processValue = undefined;
  try {
    if (k === 'VUE_APP_API_URL') { processValue = process.env.VUE_APP_API_URL; }
    else if (k === 'VUE_APP_WHITELABEL_NAME') { processValue = process.env.VUE_APP_WHITELABEL_NAME; }
    else if (k === 'VUE_APP_WHITELABEL_LOGO') { processValue = process.env.VUE_APP_WHITELABEL_LOGO; }
    else if (k === 'VUE_APP_UPLOAD_VERSION_MODE') { processValue = process.env.VUE_APP_UPLOAD_VERSION_MODE; }
    else if (k === 'environment') { processValue = process.env.environment; }
    else {
      const processEnv = typeof process !== 'undefined' && process.env !== undefined && process.env !== null ? process.env : null;
      processValue = processEnv !== null ? processEnv[k] : undefined;
    }
  } catch (e) {}

  if (isRealValue(processValue) === true) {
    return processValue.trim();
  }

  return null;
}

function normalizeBaseUrl(value) {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (raw.length === 0) {
    return '';
  }
  const withoutTrailingSlash = raw.endsWith('/') === true ? raw.slice(0, raw.length - 1) : raw;
  return withoutTrailingSlash;
}

const apiUrl = getRuntimeEnvValue('VUE_APP_API_URL');
const legacyApiUrl = getRuntimeEnvValue('vueAppApiDomain');
const baseURL = normalizeBaseUrl(apiUrl !== null ? apiUrl : (legacyApiUrl !== null ? legacyApiUrl : ''));

const axiosInstance = axios.create({
  baseURL,
  withCredentials: true
})

applyAxiosAuth(axiosInstance, null);

export default axiosInstance;
